export default '/build/a6982502.svg'